import React from 'react';
import { motion } from 'framer-motion';
export function CTAFooter() {
  return <footer className="relative bg-gray-100 pt-32 pb-12 overflow-hidden" data-id="element-67">
      {/* Decorative gradient orb */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 0.1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.5
    }} className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-t from-steel-400 to-transparent rounded-full blur-[120px] pointer-events-none" data-id="element-68" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center flex flex-col items-center mb-32" data-id="element-69">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-slate-900 leading-tight mb-6" data-id="element-70">
          Ready to meet your new operations partner?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-xl text-slate-900/70 mb-10" data-id="element-71">
          Let's discuss how our dedicated team can support your brokerage.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-72">
          <a href="https://calendly.com/dheera/mach-consultation-call" target="_blank" rel="noopener noreferrer" className="inline-block bg-slate-800 text-gray-50 px-16 py-4 font-medium text-sm tracking-widest uppercase transition-transform active:scale-95 hover:bg-slate-900 shadow-xl shadow-slate-900/20 no-underline rounded-md" data-id="element-73">
            Schedule a Call
          </a>
        </motion.div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-8 border-t border-gray-200/60 text-sm text-slate-900/50 text-center" data-id="element-74">
        <div data-id="element-75">© 2026 Mach. All rights reserved.</div>
      </div>
    </footer>;
}